import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { LegacyYammer } from './types';

export type LegacyYammerAction = SessionConfigureAction;

const initialState: LegacyYammer = {
  clientId: '',
};

const reducer: Reducer<LegacyYammer, LegacyYammerAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.legacyYammer;
    default:
      return state;
  }
};

export default reducer;
